export const RatingSection = () => {
    const reviewData = [
        {
            quote: <>이력서에 한 줄 추가했을 뿐인데,<br />면접 기회가 확 늘었어요!</>,
            name: "김지훈 (대기업 해외영업 지원자)",
            content:
                "AI 번역 자격증을 취득하고 나서 지원한 회사에서 관심을 보이더라고요. 특히, AI 활용 능력을 강조할 수 있어서 취업에 큰 도움이 되었습니다.",
        },
        {
            quote: <>회사에서 인정받아<br />프로젝트 리더로 발탁됐어요!</>,
            name: "박민재 (IT기업 글로벌 콘텐츠 담당자)",
            content:
                "기존 번역 업무를 AI로 더 효율적으로 할 수 있게 되면서 회사에서도 저를 높게 평가해 주었어요. 자격증 덕분에 중요한 프로젝트를 맡게 됐습니다.",
        },
        {
            quote: <>프리랜서 번역가로 활동하는데<br />신뢰도가 높아졌어요.</>,
            name: "정윤아 (유튜브 번역 전문가)",
            content:
                "클라이언트에게 AI 번역 자격증을 보여주니 더 신뢰하고 맡기는 경우가 많아졌어요. 특히 웹번역, 유튜브 번역 자격증이 실무에서 큰 강점이 됩니다.",
        },
        {
            quote: <>AI 번역 도구를 잘 활용하는게<br />이렇게 중요한지 몰랐어요!</>,
            name: "최도현 (스타트업 마케팅 담당자)",
            content:
                "시험을 준비하면서 단순한 번역이 아니라, AI와 협업하는 방법을 배울 수 있었어요. 번역을 더 빠르고 정확하게 할 수 있게 되었습니다.",
        },
    ];

    
    return (
        <section className={`py-20 px-24 bg-white text-center flex-col`}>
            <div className={`w-full`}>
                <h5 className={`text-sm font-bold text-blue-600`}>Real Stories, Real Success</h5>
                <h1 className={`text-3xl `}>자격증 하나로 달라진 커리어와 실력, 직접 확인하세요!
                
                </h1>
                <h3 className={`text-xl mt-1`}>AITe 번역 자격증을 통해 취업, 실력 향상, 커리어 성장을 경험한 수많은 합격자들의 이야기</h3>
            </div>
            
         <div className={`flex gap-8 mt-16`}>
             {reviewData.map((item,idx) => {
                 return <div className={`text-left`}>
                     <h1 className={`text-xl font-bold`}>{'"'}{item.quote}{'"'}</h1>
                     <p className={`text-sm  my-2`}>{item.name}</p>
                     <p className={`text-lg pr-4`}>{item.content}</p>
                     <div>⭐ ⭐ ⭐ ⭐ ⭐</div>
                 </div>
             })}
         </div>
        
        </section>
    )
}